import { type TouchEvent, useCallback } from 'react'
import { useIsMobileVariant } from '../../theme'
import { Box } from '../../primitives/Box'
import { SwipeableDrawer as PrimitiveSwipeableDrawer } from '../../primitives/SwipeableDrawer'
import { type SwipeableDrawerProps } from '../../primitives/SwipeableDrawer/SwipeableDrawer'

export type { SwipeableDrawerProps }

export const SwipeableDrawer = ({
  children,
  onClose,
  onOpen,
  onBack,
  open,
  isSwipeable = false,
  swipeCloseMode = 'modal',
  ...props
}: SwipeableDrawerProps) => {
  const isMobile = useIsMobileVariant()

  const handleTouchStart = useCallback(
    (event: TouchEvent) => {
      if (!isSwipeable || !isMobile) {
        event.stopPropagation()
        return
      }

      const touch = event.changedTouches[0]

      if (!touch) {
        return
      }

      const { clientX, clientY } = touch

      const currentTarget = document.elementFromPoint(clientX, clientY)

      if (swipeCloseMode === 'handle' && currentTarget && !currentTarget.className?.includes?.('DhlDrawer-edge')) {
        event.stopPropagation()
      }
    },
    [isSwipeable, isMobile, swipeCloseMode]
  )

  return (
    <PrimitiveSwipeableDrawer {...props} open={open} onTouchStart={handleTouchStart} onClose={onClose} onOpen={onOpen}>
      {isSwipeable && isMobile && (
        <Box className="DhlDrawer-edge">
          <Box className="DhlDrawer-edge-inner" />
        </Box>
      )}
      {children}
    </PrimitiveSwipeableDrawer>
  )
}
